enum SubAppsEnum {
    feedbacks = 'feedbacks',
    objectives = 'objectives',
    followUps = 'follow-ups',
    career = 'career',
    overallAssessment = 'overallAssessment',
    team = 'team',
    year = 'year',
    businesCategories = 'busines-categories',
    regions = 'regions',
    reports = 'reports',
    offices = 'mfiles-offices',
    departement = 'departement',
    groups = 'groups',
    managers = 'managers',
    managerTypes = 'manager-types',
    groupSize = 'group-size',
    typeSize = 'type-size',
    hrlevel = 'hrlevel',
    objectiveSynergy = 'objective-synergy',
    exception = 'exception',
    ajustement = 'ajustement',
    configuration = 'configuration',
    groupType = 'group-type',
    notes = 'notes',
}

export default SubAppsEnum;
